exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ag-root .mCSB_scrollTools_horizontal {\r\n  bottom: 0 !important;\r\n}\r\n\r\n.ag-root .mCSB_scrollTools_vertical, .ag-root .mCSB_scrollTools_horizontal {\r\n  background-color: #404951;\r\n  opacity: 1;\r\n}\r\n\r\n.ag-root .ag-body-container {\r\n  margin-bottom: 16px;\r\n  margin-right: 16px;\r\n}", ""]);

